import { render, staticRenderFns } from "./HasNHBC.vue?vue&type=template&id=136033dd"
import script from "./HasNHBC.vue?vue&type=script&lang=js"
export * from "./HasNHBC.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports